import React from 'react'
import { useSelector } from 'react-redux'
import { selectTheme } from '../selectors/ui'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles'

export interface Props {
  children: React.ReactNode
}

export const Layout = ({ children }: Props) => {
  const theme = useSelector(selectTheme)

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </StyledEngineProvider>
  )
}
